export const KpiActionBarVI = {
    "kpiActionBar": {
        "tab": {
            "detail":"Chi tiết",
        },
        "item": {
            "delete": "Xóa",
            "auditing": "Lịch sử",
            "historyAction": "Lịch sử hoạt động",
            "update": "Cập nhật",
            "confirm": "Chốt",
            "notConfirm": "Hoàn chốt",
            "back": "Quay về",
            "result": "Kết quả",
            "evaluate": "Chấm điểm",
            "evaluateModal": "Chấm điểm kỳ đánh giá KPI",
            "time": "Thời gian"
        },
        "message": {
            "deleteAsk": "Bạn có chắc chắn muốn xóa KPI ?",
            "deleteTemplateAsk": "Bạn có chắc chắn muốn xóa mẫu đánh giá KPI ?",
            "deletePeriodAsk": "Bạn có chắc chắn muốn xóa kỳ đánh giá KPI ?",
            "confirmAsk": "Bạn có chắc chắn muốn chốt kỳ đánh giá KPI ?",
            "notConfirmAsk": "Bạn có chắc chắn muốn hoàn chốt kỳ đánh giá KPI ?",
        }
    }
}